import React, { useMemo, useCallback } from "react";
import { groupAnnoFilters } from "./utils/groupAnnoFilters";
import { AppliedFilterBlock } from "../AppliedFilters/AppliedFilterBlock";
import { StyledBlocksWrapper } from "../AppliedFilters/styled";
import { FilterLightbox } from "../AppliedFilters/FilterLightbox";

export const AnnoAppliedFiltersBlocks = ({ activeFilters, onChange, annoFilterConfig, savedConfigs = [], onIntraFilterOperatorChange, onRemoveSavedConfig, contentTypes, disableInlinePadding, noAppliedValueChipsTruncation = false }) => {
  const blocks = useMemo(
    () => groupAnnoFilters(activeFilters, annoFilterConfig, savedConfigs),
    [activeFilters, annoFilterConfig, savedConfigs]
  );

  const renderLightbox = useCallback(
    ({ block, activeFilters, onChange, onOpenChange, children }) => (
      <FilterLightbox
        block={block}
        activeFilters={activeFilters}
        onChange={onChange}
        annoFilterConfig={annoFilterConfig}
        onOpenChange={onOpenChange}
        contentTypes={contentTypes}
      >
        {children}
      </FilterLightbox>
    ),
    [annoFilterConfig, contentTypes]
  );

  if (blocks.length === 0) return null;

  // Sub-themes/tags carry intraFilterOperator as a per-bucket map keyed by
  // annoFilterBucketKey; themes carry it as a plain string (like doc filters).
  const readIntraFilterOperator = (block) => {
    const intraFilterOperator = activeFilters.find((f) => f.filterId === block.filterId)?.intraFilterOperator;
    if (block.annoFilterBucketKey != null) {
      return (intraFilterOperator && typeof intraFilterOperator === "object"
        ? intraFilterOperator[block.annoFilterBucketKey]
        : null) || "OR";
    }
    return intraFilterOperator || "OR";
  };

  return (
    <StyledBlocksWrapper $disableInlinePadding={disableInlinePadding}>
      {blocks.map((block) => (
        <AppliedFilterBlock
          key={block.key}
          block={block}
          activeFilters={activeFilters}
          onChange={onChange}
          renderLightbox={renderLightbox}
          showIndependentLabel={true}
          intraFilterOperator={readIntraFilterOperator(block)}
          onIntraFilterOperatorChange={onIntraFilterOperatorChange}
          onRemoveSavedConfig={onRemoveSavedConfig}
          contentTypes={contentTypes}
          noAppliedValueChipsTruncation={noAppliedValueChipsTruncation}
        />
      ))}
    </StyledBlocksWrapper>
  );
};
